export enum StagingScanModal {
  GAYLORD_NOT_FOUND = "STAGING_SCAN_GAYLORD_NOT_FOUND",
  UNKNOWN_ERROR = "STAGING_SCAN_UNKNOWN_ERROR",
}
